const prefix = 'PAGES/';

export const EDIT_PAGE_SETTINGS = `${prefix}EDIT_PAGE_SETTINGS`;
export const UPDATE_PAGE_CONTENT = `${prefix}UPDATE_PAGE_CONTENT`;
export const CHANGE_PAGE_SETTING = `${prefix}CHANGE_PAGE_SETTING`;
